import { initialServersState } from '../servers'

export const localBrokerConfig = {
  WSSHost: initialServersState.serverMap.metricsServer.defaultBroker,
  Username: 'metrics_server',
  Password: 'Sp0rtableT3ch',
  SportscasterHost: initialServersState.serverMap.sportscaster.defaultBroker,
  Host: 'host',
  protocol:
    initialServersState.serverMap.metricsServer.defaultMQTTBrokerProtocol,
  path: '/ws',
  name: 'host'
}
